import appConfig from '../../../../app-config';

export const initialDynamicOrderMethodType = () => {
  const isDeliveryEnabled =
    appConfig.isDeliveryEnabled || appConfig.isFutureOrderDelivery;
  const isPickUpEnabled =
    appConfig.isPickUpEnabled || appConfig.isFutureOrderPickup;

  if (isPickUpEnabled && isDeliveryEnabled) return 'pickup';
  else if (isPickUpEnabled && !isDeliveryEnabled) return 'pickup';
  else if (isDeliveryEnabled && !isPickUpEnabled) return 'delivery';
  else return null;
};

export const formatLocationLabelAsString = (
  location,
  nearestLocation,
  coords
) => {
  let parts = [];
  let isNearestLocation = nearestLocation && location.id === nearestLocation.id;
  if (!location.accepting_orders || !location.is_order_ahead_enabled) {
    parts.push('💤 Closed');
  }

  parts.push(location.name);
  parts.push(location.distance);

  if (isNearestLocation) {
    parts.push('(Nearest Location)');
  }

  return {
    ...location,
    label: coords ? parts.join(' - ') : parts[0],
    isNearestLocation,
  };
};
